/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ProgramEnvironmentalBenefitsTargetValueViewer} from "./ProgramEnvironmentalBenefitsTargetValueViewer";
import autobind from "autobind-decorator";

export class ProjectedProgramEnvironmentalBenefitsTargetValueViewer extends ProgramEnvironmentalBenefitsTargetValueViewer {
	//override
	@autobind
	getSelectedBenefitId() {
		let ret = -1;
		let thisId = this.props.Data.programEnvironmentalBenefitProjectionId || this.props.Data._tempId;

		if (this.props.RootData.ProgramEnvironmentalBenefits) {
			this.props.RootData.ProgramEnvironmentalBenefits.forEach((x) => {
				if (x.ProgramEnvironmentalBenefitProjections && x.ProgramEnvironmentalBenefitProjections.some((y) => y.programEnvironmentalBenefitProjectionId == thisId)) {
					ret = x.environmentalBenefitId;
				}
			});
		}

		return ret;
	}
}